<template>
  <!-- <div v-if="!verified">
      <plans msgtitle="You currently do not have access to view Files under Data Sources"
            msgdescription="Please choose a plan to pay to enjoy the Data Sources feature"
      ></plans>
  </div> -->
  <div class="">
    <b-card>
      <b-row>
        <b-col cols :md=12>
          <!-- <b-button class="ml-4" variant="primary" @click="goBackToDataSources()">
            Back to Projects
          </b-button> -->
          <b-card style="position: relative;" class="mb-0">
            <b-row class="mb-2">
              <b-col :cols="10">
                <list-control label="Rows per Page">
                  <b-input
                    block
                    v-model="rowsPerPage"
                    type="number"/>
                </list-control>

                <template>
                  <list-control label="Sort By" width="180px">
                    <b-select
                      block
                      v-model="sortBy"
                      :options="sortByColumns"/>
                  </list-control>

                  <list-control label="Sort Order">
                    <b-select
                      block
                      v-model="sortOrder"
                      :options="[{value: 1, text: 'ascending'}, {value: 0, text: 'descending'}]"/>
                  </list-control>
                </template>

                <list-control
                  label="Filter"
                  width="180px"
                  >
                  <b-input v-model="search" placeholder="Search active columns"/>
                </list-control>

                <list-control>
                  <b-button @click="handleApply" variant="primary" >Apply</b-button>
                </list-control>
              </b-col>

              <b-col :cols="2" class="text-right">
                <list-control :label="`${columns.length} columns`" width="100%">
                  <b-dropdown text="Active columns">
                    <div
                      v-for="col in displayColumns"
                      :key="col"
                      class="dropdown-item text-body">
                      <b-form-checkbox
                        v-model="columns"
                        name="columns"
                        :value="col">
                        {{ titleCase(col) }}
                      </b-form-checkbox>
                    </div>
                  </b-dropdown>
                </list-control>
              </b-col>
            </b-row>

            <div style="overflow-x: auto;">
              <b-table
                small
                striped
                hover
                head-variant="dark"
                :filter="search"
                @filtered="onFiltered"

                :items="files"
                :current-page="currentPage"
                :per-page="perPage"
                :fields="[{key: '#'}, ...tableFields, {key: '__action', label: ''}]">
                <template v-slot:cell(#)="data">
                  {{ (((currentPage)?currentPage-1:0) * ((rowsPerPage)?rowsPerPage:20)) + data.index + 1}}
                </template>
                <template v-slot:cell()="data">
                  <template v-if="checkArrayContainsObject(data.value)">
                    {{data.value.length}} rows
                    <b-button
                    variant="link"
                    @click="open_table(data)">View details</b-button>

                  </template>
                  
                  <template v-else-if="checkArrayContainsIDs(data.value)">
                    {{data.value.length}} rows
                    <b-button
                      variant="link"
                      @click="open_table(data)">
                            View details
                    </b-button>

                  </template>
                  <template v-else-if="isObject(data.value)">
                    {{[data.value].length}} rows
                    <b-button
                      variant="link"
                      @click="open_table(data)">
                            View details
                    </b-button>

                  </template>
                  <!-- <template v-else-if="checkDateField(data.field.key)">
                    {{formatDate(data.value)}}
                  </template> -->
                  <template v-else>
                    {{data.value}}
                  </template>
                </template>

                <template v-slot:cell(__action)="data">
                  <div class="text-right">
                    <!-- <b-button
                      variant="info"
                      size="sm"
                      class="mr-2"
                      @click="updateProject(data.item.id)">
                      Edit
                      <span class="ml-1" v-if="actionText">

                      </span>
                    </b-button> -->
                    <b-button
                      variant="outline-danger"
                      size="sm"
                      @click="launchDeleteConfirmationModal(data.item)">
                      Delete
                      <span class="ml-1" v-if="actionText">

                      </span>
                    </b-button>
                  </div>
                </template>
                <template v-slot:empty="scope">
                  <div class="my-5 py-5 text-center">
                    <h6 v-if="items">{{ scope.emptyText }}</h6>
                    <i v-else class="fa fa-spinner fa-spin fa-2x"/>
                  </div>
                </template>
              </b-table>
            </div>

            <b-row v-if="totalRows" class="pt-2" @sort-changed="sortingChanged"
                style="vertical-align: top; border-top: 1px solid lightgrey;">
              <b-col :cols="12">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  aria-controls="my-table"
                ></b-pagination>
              </b-col>
              </b-row>
            <div v-if="data_gotten != null">
              <nested-table
                :nested_data="data_gotten"
                :_key="table_key"
                :table_name="table_name"
                @close="data_gotten = null"/>
            </div>

            <div v-if="isLoadingPage" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0;
                  background: rgba(255, 255, 255, .3); border-radius: 5px;">
              <align-middle>
                <div class="text-center">
                  <strong class="fa fa-3x fa-spin fa-spinner"/>
                </div>
              </align-middle>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-card>
  </div>

</template>

<script>
  import {titleCase} from '../Insights/utils';
  import SourceHeader from './SourceHeader';
  import AlignMiddle from './AlignMiddle';
  import {fullURL, hasAllRequiredEntities} from '../../utils';
  import {maybeMissingValueLabel} from '../Insights/utils';
  import Plans from '../Plans/Plans'
  import CardDetail from '../CardDetail';
  import ListControl from '../Insights/ListControl';
  import {getCookie, setCookie} from '../../utils';
  import { deleteUploadedFile, fetchActiveProject } from '../../store/files';
  import NestedTable from '../List/NestedTable';
  import VueSweetalert2 from 'vue-sweetalert2';
  import swal from 'sweetalert2';
  import moment from "moment";
  import axios from 'axios';


  window.Swal = swal;
  
  export default {
    name: 'Files',
    components: {
      CardDetail,
      SourceHeader,
      AlignMiddle,
      ListControl,
      NestedTable,
      Plans
    },

    props: {
      allFiles: Array
    },

    data() {
      // const columns = Object.keys(this.values[0]);
      var fileList = this.$store.state.files.fileList;
      /* var allFiles = [];
      fileList.forEach(f => {
        console.log("Dates: ", f);
        f['createdAt'] = this.formatDate(f['createdAt']);
        allFiles.push(f);
      }); */
      var allColumns = Object.keys(fileList[0]);

      var fields = [];
      console.log("Check Date: ", fileList[0]['createdAt']);
      allColumns.forEach(column => {
        fields.push({key: column, sortable: true})
      });

      return {
        totalSteps: 3,
        createProject: false,
        rawFile: null,
        verified: this.$store.state.general.user.verified,
        // allFiles: this.$store.state.files.fileList,
        isReady: false,
        modalKey: 1,
        files: [],
        fileOperation: 'new_file',
        fileOperationOptions: [
          {text: 'Upload File', value: 'new_file'},
          {text: 'Select Existing File', value: 'existing_file'}
        ],

        totalRows: fileList.length,
        defaultColumns: ['id', 'originalName', 'rowCount', 'size', 'createdAt'],
        data_gotten: null,
        actionText: "select-file",
        columns: [],
        valueLabel: maybeMissingValueLabel,
        enableSort: true,
        enableFilter: true,
        fields: fields,
        perPage: 10,
        currentPage: 1,
        rowCount: 0,
        allColumns: allColumns,
        search: '',
        sortBy: null,
        sortOrder: 0,
        rowsPerPage: 10,
        isLoadingPage: false,
        activeDataPage: 0,
        startPosition: 0,
        titleCase,
        modalKey: 1,
        selectedProject: null,
        hasClickedEditProject: false
      };
    },
    created() {
      // this.readFromFakeMemory();
      // this.allFiles = this.$store.state.files.fileList;
      this.files = this.getFiles();
      this.doColumnsCleanup();
    },
    mounted(){
      
    },
    watch: {
      rawFile: function(val) {
        console.log('Raw file: ', val);
        if (!!val) {
          this.file = val;
        }
      },
    },

    methods: {
      renewModalKey() {
        this.modalKey = this.modalKey + 1;
      },

      toggleProjectLabel(value, event) {
        this.createProject = value['save'];
      },

      goBackToDataSources() {
        this.$router.push(`/sources`);
      },

      launchProjectUpdateModal() {
        this.hasClickedEditProject = true;
      },

      sortingChanged(e) {
        this.sortBy = e.sortBy;
        this.sortOrder = e.sortOrder;
      },

      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        console.log('items', filteredItems)
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
      },

      checkArrayContainsObject(label) {
        return Object.prototype.toString.call(label) === '[object Array]' && Object.prototype.toString.call(label[0]) === '[object Object]' ;
      },
      
      checkArrayContainsIDs(label) {
        return Object.prototype.toString.call(label) === '[object Array]' && Object.prototype.toString.call(label[0]) != '[object Object]' ;
      },

      checkDateField(field) {
        return (field === 'createAt') ? true : false;
      },

      isObject(label) {
        return Object.prototype.toString.call(label) == '[object Object]' ;
      },
      
      formatDate(date) {
        return moment(date).fromNow();
      },

      open_table(x=null) {
        if (this.checkArrayContainsObject(x.value)){
            this.data_gotten = x.value;
        }

        else if (this.checkArrayContainsIDs(x.value)){
          this.data_gotten = x.value.map(name => ({list_items:name}));
        }
        
        else if (this.isObject(x.value)) {
          this.data_gotten = [x.value];
        }
        this.table_key = (new Date()).getMilliseconds().toString();
        this.table_name = x.field.label;
      },

      resetInsightsData() {
        this.items = null;
        this.rowCount = 0;
      },

      async act(record) {
        const { value: email } = await Swal.fire({
          title: 'Enter email address',
          input: 'email',
          inputPlaceholder: 'Enter your email address'
        })

        if (email) {
          Swal.fire('Success', 'The email report has been sent', 'success')
          record['confirmed_email'] = email;
          this.$emit('act', record);
        }
      },

      projectUpdate() {
        this.hasClickedEditProject = false;
        this.$bvToast.toast('Project has been updated successfully', {
          title: 'Successful',
          autoHideDelay: 5000000,
          variant: 'success',
          solid: true
        });
      },

      updateProject(projectId) {
        this.selectedProject = this.getProject(projectId);
        this.launchProjectUpdateModal();
      },

      launchDeleteConfirmationModal(file) {
        // const { value: confirmDele } = await 
        Swal.fire({
          title: "<span style='color: #fff; font-size: 1.4rem'><span style='color: #fc0'>" + file.originalName + "</span><br/>Are you sure you want to delete this file?</span>",
          text: "<span style='color: #fff'>You won't be able to revert this!</span>",
          icon: 'warning',
          html: "<span style='color: #fff'>You won't be able to revert this!</span>",
        
          background: "#3a4149",
       
          confirmButtonColor: '#ae0d0d',
          cancelButtonColor: '#06f',
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "Cancel",
          closeOnConfirm: false,
          closeOnCancel: false,
          reverseButtons: true
          // denyButtonText: `Don't save`,
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.deleteFile(file);


          } else if (result.isDenied) {
            // Swal.fire('Changes are not saved', '', 'info')
          }
        })
      },

      deleteFile(file) {
        this.isSaving = true;
        console.log("Deleting file: ", file.id);
        
        // this.$store.dispatch(deleteUploadedFile(fileId))
        axios.delete(fullURL(`/file/delete/${file.id}`))
          .then(() => {
            // this.files = this.refreshFiles(fileId);
            this.files = this.files.filter(e => e.id != file.id);
            this.$bvToast.toast('File has been deleted successfully', {
              title: 'Successful',
              autoHideDelay: 5000000,
              variant: 'success',
              solid: true
            });
            this.isSaving = false;
            this.$emit('success');
            // this.$store.dispatch(fetchActiveProject())
            // .then(() => {
              
            // })
            // .catch(console.log)
            // .finally(() => {
              
            // });
          })
          .catch(console.log)
          .finally(() => {
            this.isSaving = false;
          });
      },
      
      refreshFiles(fileId) {
        for (let i=0; i < this.files.length; i++) {
          if (this.files[i]['_id'] === fileId) {
            console.log("File: ", this.files[i]['_id'], fileId);
            delete this.files[i];
          }
        }
        return this.files;
      },
      
      formatDate(date) {
        // return moment(date).format(dateFormat);
        return moment(date).fromNow();
      },

      refreshProjects() {
        var projects = [];
        var files = {};
        this.$store.state.files.fileList.forEach(f => {
          files[f['_id']] = f['originalName'];
          // files.push(file);
        });
        this.$store.state.files.projectList.forEach(p => {
          var project = {};
          project['id'] = p.id;
          project['name'] = p.name;
          project['description'] = p.description;
          // console.log("Details: ", p.fieldMap, p.files);
          if (!!p.fieldMap) {
            project['fieldMap'] = {};
            Object.keys(p.fieldMap).forEach(file_id => {
              project['fieldMap'][files[file_id]] = p.fieldMap[file_id];
            });
          }
          if (!!p.files) {
            project['files'] = {};
            Object.keys(p.files).forEach(type => {
              project['files'][type] = files[p.files[type]];
            });
          }
          project['created'] = this.formatDate(p.createdAt);
          // project['name'] = p.name;
          projects.push(project);
        });
        return projects;
      },

      doColumnsCleanup() {
        var cols = [];
        this.allColumns.forEach(col => {
          if (!['id', '_id', 'columns', 'name', 'entityMap', 'fieldMap'].includes(col)) {
            cols.push(col);
          }
        });
        const columns = this.cols;
        const exists = slug => !!columns.find(col => col.slug === slug);
        this.columns = this.columns.filter(exists);
        // if (this.columns.length === 0) {
          
        // }
        this.columns =
            this.defaultColumns && this.defaultColumns.length > 0 ?
              [...this.defaultColumns] :
              columns.slice(0, 6)
                .map(col => col);
        if (!this.sortBy || !exists(this.sortBy)) {
          this.sortBy = this.defaultSortBy || null;
        }
      },

      handleApply() {
        console.log("Sort by: ", this.sortBy);
        console.log("Sort by: ", this.sortOrder);
        // values = 
        // this.compute(true);
      },

      getFiles() {
        console.log("Files: ", this.allFiles);
        var allFiles = this.allFiles;
        var files = [];
        if (!!allFiles || allFiles.length === 0) {
          allFiles = this.$store.state.files.fileList;
        }
        if (!!this.search && this.search.length > 0) {
          allFiles.forEach(value => {
            if (value['originalName'].indexOf(this.search) > -1) {
              value['createdAt'] = this.formatDate(value['createdAt']);
              files.push(value);
            }
          });
        } 
        else {
          /* this.allFiles.forEach(value => {
            value['createdAt'] = this.formatDate(value['createdAt']);
            files.push(value);
          }); */
          files = allFiles;
        }
        return files;
      }
    },

    computed: {
      fileDetails() {
        var files = [];
        this.$store.state.files.fileList.forEach(file => {
          files.push(file);
        });
        return files;
      },

      rawFiles() {
        return this.$store.state.files.fileList
      },
      
      /* files() {
        // var files = [];
        // this.$store.state.files.fileList.forEach(file => {
        //   files.push(file.originalName);
        // });
        // return files;
        console.log("Files: ", this.allFiles);
        var files = [];
        if (!!this.search && this.search.length > 0) {
          this.allFiles.forEach(value => {
            if (value['originalName'].indexOf(this.search) > -1) {
              value['createdAt'] = this.formatDate(value['createdAt']);
              files.push(value);
            }
          });
        } 
        else {
          this.allFiles.forEach(value => {
            value['createdAt'] = this.formatDate(value['createdAt']);
            files.push(value);
          });
          // files = this.allFiles;
        }
        return files;
      }, */

      cookieKey() {
        return `_fake_mem_${this.insightId}_6`;
      },

      tableFields() {
        var columns = [];
        var colMap = {};
        this.allColumns.forEach(column => {
          if (!['id', '_id', 'columns', 'name', 'entityMap', 'fieldMap'].includes(column)) {
            colMap[column] = {key: column, label: titleCase(column), sortable: false};
          }
        });

        this.columns.forEach(column => {
          if (!['id', '_id', 'columns', 'name', 'entityMap', 'fieldMap'].includes(column)) {
            columns.push(column);
          }
        });

        return columns.map(column => ({
          key: column,
          label: titleCase(column),
          sortable: true,
        }));

        // return columns;
      },

      displayColumns() {
        var columns = [];
        this.allColumns.forEach(col => {
          if (!['id', '_id', 'columns', 'name', 'entityMap', 'fieldMap'].includes(col)) {
            columns.push(col);
          }
        });
        return columns;
      },
      
      sortByColumns() {
        return this.tableFields.map(
          ({key, label}) => ({value: key, text: label}));
      },

      rows() {
        return this.fileList.length;
      },

      style() {
        return {
          maxHeight: "100%",
          // height: "130%",
          overflowY: 'auto',
          borderRadius: 4
        };
      }
    }
  };
</script>

<style scoped>

</style>
